<template>
  <transition name="fade">
    <div class="pnlDialogBg" v-if="show" style="animation-duration: 0.3s">
      <div class="pnlDialogAlpha" @click.self="CloseDialog">
        <div class="pnlDialogAccount scrollBar">
          <img class="btnDialogXX" src="@/assets/img/controller/icon_close.png" @click="CloseDialog" />
          <img class="accountIcon" src="@/assets/img/controller/icon_account_2.png" />
          <div class="accountName">{{ $t('Controller.AccountName') }}</div>
          <div class="accountEmail">{{ accountEmail }}</div>
          <div class="accountLogout" @click="Logout">{{ $t('Controller.Logout') }}</div>
          <div class="pnlContent">
            <label class="lblContent" v-html="content"></label>
          </div>
          <hr />
          <div class="languageSetting">{{ $t('Controller.AccountLanguage') }}</div>
          <div class="languageItems">
            <div
              v-for="option in languageOptions"
              :key="option.languageId"
              :class="languageSelect == option.languageId ? 'languageItemSelecet' : 'languageItemUnSelecet'"
              @click="ChangeLanguage(option)"
            >
              {{ option.languageName }}
            </div>
            <!-- <div class="languageItemUnSelecet">日本語</div> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { apiEditAccount } from '@/request.js';

export default {
  name: 'DialogAccount',
  props: {
    show: Boolean,
    title: String,
    content: String,
    logoutPath: String,
  },
  data() {
    return {
      languageOptions: [],
      languageSelect: '',
      accountName: '',
      accountEmail: '',
    };
  },
  mounted() {
    this.languageOptions = JSON.parse(localStorage.getItem('languageList'));
    this.languageSelect = localStorage.getItem('nowLanguageID');
    this.accountName = localStorage.getItem('name');
    this.accountEmail = localStorage.getItem('account');
  },
  methods: {
    Logout() {
      this.$store.dispatch('LOGOUT');
      this.$router.push({ path: this.logoutPath });
    },
    CloseDialog() {
      this.$emit('close-dialog');
    },
    BtnRightClick() {
      this.$emit('btn-right-click');
    },
    BtnLeftClick() {
      this.$emit('btn-left-click');
    },
    ChangeLanguage(item) {
      var data = {
        name: this.accountName,
        language: item.languageId,
      };
      apiEditAccount(data).then((res) => {
        if (res.data.status == 'ok') {
          this.languageSelect = item.languageId;
          localStorage.setItem('nowLanguageID', this.languageSelect);
          this.$i18n.locale = localStorage.getItem('nowLanguageID');
          this.$router.go(); //refresh page
        }
      });
    },
  },
};
</script>